import { render, staticRenderFns } from "./SelectAbschluss.vue?vue&type=template&id=0074374d"
import script from "./SelectAbschluss.vue?vue&type=script&lang=js"
export * from "./SelectAbschluss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports